<template>
    <FilterBody
        v-model:search-model-value="ownerFilterProperties.searchTerm"
        :label="t('projectclient.projectlist.table.projectOwner.header')"
        :display-search="true"
        :search-placeholder="t('projectclient.projectlist.topbar.filters.owners.search.placeholder')"
        :items="ownerFilterProperties.displayedResults"
        :selected-items="screenSizeSearchParams.owners"
        :pending="ownerFilterProperties.pending"
        :display-show-more="ownerFilterProperties.hasMoreToShow && !ownerFilterProperties.isSearchActive"
        @reset="projectListFiltersStore.handleResetCategory('owners')"
        @check:item="handleCheckBoxChange"
        @show-more="handleShowMore"
    >
        <template #item="{item}">
            {{
                `${item.label === 'deleted.account.firstName' ? t('deleted.account.firstName') : item.label} ${
                    item.count > 0 ? `(${item.count})` : ''
                }`
            }}
        </template>
    </FilterBody>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import type {TypedAggregationResource} from '@common/composables';
    import {useScreenSizeStore} from '@common/stores';
    import {useProjectsListStore, useProjectsListFiltersStore} from '@features/projects-list/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import FilterBody from '../wrappers/FilterBody.vue';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isSmallScreen} = storeToRefs(screenSizeStore);

    const projectListStore = useProjectsListStore();
    const {searchParams} = storeToRefs(projectListStore);

    const projectListFiltersStore = useProjectsListFiltersStore();
    const {temporarySearchParams, ownerFilterProperties} = storeToRefs(projectListFiltersStore);

    const screenSizeSearchParams = computed(() => {
        if (isSmallScreen.value) {
            return temporarySearchParams.value;
        } else {
            return searchParams.value;
        }
    });

    function handleCheckBoxChange(item: TypedAggregationResource<string>) {
        projectListFiltersStore.handleUpdateCategory('owners', item.value);
    }

    function handleShowMore() {
        ownerFilterProperties.value.resultsSize += 6;
    }
</script>
